import { render, staticRenderFns } from "./ImportFileContacts.vue?vue&type=template&id=5c84300b&"
import script from "./ImportFileContacts.vue?vue&type=script&lang=js&"
export * from "./ImportFileContacts.vue?vue&type=script&lang=js&"
import style0 from "./ImportFileContacts.vue?vue&type=style&index=0&id=5c84300b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports